import { api, ApiError } from './api';

/**
 * إصدار فاتورة عن عرض مقبول — مع سؤالٍ قبل الإصدار عن عقدٍ من شيت الحسابات.
 *
 * الخادم يرفض أوّل مرّة بـ409 حين يكون العقد من الشيت (مستحقّه مقيَّد هناك
 * بالفعل)، فتُعرض رسالته على المستخدم: إن أكّد أُعيد الطلب بالتأكيد، وإلا
 * لم يُصدَر شيء.
 */
export async function issueInvoiceFromQuotation(quotationId: string): Promise<{ id: string }> {
  const path = `/finance/invoices/from-quotation/${quotationId}`;
  try {
    return await api<{ id: string }>(path, { method: 'POST' });
  } catch (err) {
    if (!(err instanceof ApiError) || err.status !== 409 || !err.message.startsWith('تنبيه:')) throw err;
    if (!window.confirm(`${err.message}\n\nهل تريد إصدار الفاتورة رغم ذلك؟`)) {
      throw new Error('لم تُصدر الفاتورة.');
    }
    return api<{ id: string }>(`${path}?confirm=sheet`, { method: 'POST' });
  }
}
